import { useContext, useEffect, useRef, useState } from "react";
import { ReactComponent as People } from "../../../../assets/img/icon/people_black_24dp.svg";
import { ReactComponent as PersonAdd } from "../../../../assets/img/icon/person_add_black_24dp.svg";
import { COLOR } from "../../../../config/constant";
import { Patient } from "../../../../models/Patient";
import { getPatient } from "../../../../services/httpService/patientRequest";
import { GlobalContext } from "../../../contexts/globalContext";
import Button from "../../../ui/atoms/Button/Button";
import CardPatient from "../../../ui/atoms/CardPatient/CardPatient";
import ExpandData from "../../../ui/atoms/ExpandData/ExpandData";
import PageTitle from "../../../ui/atoms/PageTitle/PageTitle";
import ModalPatientRegister from "../../../ui/organisms/ModalPatientRegister/ModalPatientRegister";

const LIMIT = 9;
const PatientList = () => {
  const isMounted = useRef(true);
  const [state, setState] = useState({
    page: 1,
    tpage: 0,
    count: 0,
    name: "",
    message: null,
  });
  const [loading, setLoading] = useState(true);
  const [patients, setPatients] = useState(new Array(LIMIT).fill(0));
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [modal, setModal] = useState(null);
  const handleCloseModal = () => {
    setModal(null);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleGetPatient = async (data) => {
    try {
      setLoading(true);
      if (state.message != null)
        setState((prevState) => ({ ...prevState, message: "" }));
      let offset = 0;
      let page = state.page;
      if (data === "next") {
        page += 1;
        if (isMounted.current)
          setPatients((prevState) => [...prevState, new Array(LIMIT).fill(0)]);
      } else if (data === "prev") {
        page -= 1;
      } else if (data === "refresh") {
        page = 1;
        if (isMounted.current) setPatients(new Array(LIMIT).fill(0));
      }
      offset = (page - 1) * LIMIT;

      let param = `doctor=${sharedState.user._id}&limit=${LIMIT}&offset=${offset}`;
      if (state.name !== "") param = `${param}&name=${state.name}`;

      let { result, count } = await getPatient(param);
      result = result.map((res) => {
        return new Patient(res._id, res.user.name, res.user.profile);
      });

      let message = null;
      if (count === 0) {
        message =
          state.name !== "" ? (
            <p>{`Nama "${state.name}" tidak ada dalam daftar pasien anda.`}</p>
          ) : (
            <p>
              Sepertinya anda belum memiliki pasien. Klik{" "}
              <span
                className="cursor-pointer underline text-success "
                onClick={() => setModal("register")}
              >
                disini
              </span>{" "}
              untuk menambah pasien
            </p>
          );
      }
      const tpage = Math.ceil(count / LIMIT);
      if (page !== 1) result = [...patients, ...result];
      if (!isMounted.current) return null;
      setPatients(result);
      setState((prevState) => ({ ...prevState, tpage, page, count, message }));
      setLoading(false);
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        message: <p>{error.message} </p>,
      }));
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetPatient();
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <>
      <ModalPatientRegister
        show={modal === "register"}
        handleClose={handleCloseModal}
        handleUpdate={handleGetPatient}
      />

      <div className="mt-2 lg:mt-6">
        <PageTitle
          title="Halaman Pasien"
          description="Dapatkan informasi pasien beserta dengan riwayat medisnya."
          icon={
            <People className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 fill-current text-white" />
          }
        />

        {/* SUBMENU */}
        <div className="mt-10 flex flex-col xl:flex-row justify-start xl:justify-between items-center space-y-4 xl:space-y-0">
          {/* LEFT SUBMENU */}
          <div className="w-full xl:w-2/3 flex flex-wrap">
            <div className="w-full sm:w-2/3 md:w-96 flex space-x-2 items-center mr-2 mt-2">
              <div className="text-primary font-medium flex-shrink-0 hidden md:block">
                Pasien :
              </div>
              <input
                className="w-full border-b border-primary text-primary px-1 focus:outline-none placeholder-primary placeholder-opacity-40"
                type="text"
                placeholder="Nama Pasien"
                name="name"
                value={state.name}
                onChange={handleChange}
                onKeyPress={(e) => {
                  if (e.key === "Enter") handleGetPatient("refresh");
                }}
              />
              <Button
                className="w-24 flex-shrink-0 bg-primary rounded px-2 py-1 text-sm text-white"
                handleClick={() => {
                  handleGetPatient("refresh");
                }}
              >
                Cari
              </Button>
            </div>
          </div>
          {/* RIGHT SUBMENU */}
          <div className="w-full xl:w-1/3 flex space-x-3 justify-end mt-3 xl:mt-0">
            <div
              className="text-primary cursor-pointer flex items-center "
              onClick={() => setModal("register")}
            >
              <div>
                <PersonAdd fill={COLOR.PRIMARY} className="w-6 h-6" />
              </div>
              <div className="ml-1 border-b border-transparent hover:border-primary">
                Tambah Pasien
              </div>
            </div>
            {/* <div className="text-primary cursor-pointer flex items-center ">
              <div>
                <Pdf fill={COLOR.PRIMARY} className="w-6 h-6" />
              </div>
              <div className="ml-1 border-b border-transparent hover:border-primary">
                Eskpor Pdf
              </div>
            </div> */}
          </div>
        </div>

        <div className="mt-8 relative pt-6 ">
          {!loading &&
            (state.message === null ? (
              <p className="absolute top-1 right-0 text-sm text-gray-800 text-opacity-50 text-sm">
                <span className="hidden md:inline-block">Menampilkan</span>{" "}
                {`${patients.length} dari ${state.count} data`}
              </p>
            ) : (
              <>{state.message}</>
            ))}
          <div
            className="pt-2 pb-16 overflow-y-auto"
            style={{ maxHeight: "32rem" }}
          >
            <div className="grid grid-cols-12 gap-5 md:gap-7">
              {patients.map((patient, idx) => (
                <CardPatient
                  key={"patient-" + idx}
                  patient={patient}
                  className="col-span-12 sm:col-span-6 lg:col-span-4"
                />
              ))}
            </div>

            <ExpandData
              page={state.page}
              tpage={state.tpage}
              loading={loading}
              handleMoreData={() => handleGetPatient("next")}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientList;
